import ReactDOM from 'react-dom/client';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from './Navbar';
import './index.css';
import './Home.css';
import Footer from './Footer';
import Loading from './Loading';
import PrivateRoute from './PrivateRoute';

const LazyHome = React.lazy(() => import('./Home'));
const LazyLearning = React.lazy(() => import('./Learning'));
const LazyAbout = React.lazy(() => import('./About'));
const LazyServices = React.lazy(() => import('./Services'));
const LazyContact = React.lazy(() => import('./Contact'));
const LazyProjects = React.lazy(() => import('./Projects'));
const LazyLipSync = React.lazy(() => import('./LipSync'));
const LazyPrinciples = React.lazy(() => import('./Principles'));
const LazyMetin2 = React.lazy(() => import('./Metin2'));
const LazyRigging = React.lazy(() => import('./Rigging'));
const LazyRangeOfMovement = React.lazy(() => import('./RangeOfMovement'));

// 1. Lazy load your Productivity Dashboard file here
const LazyMindmap = React.lazy(() => import('./ProductivityDashboard'));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); 

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar/>
      <Routes>
        <Route path="/" element={<React.Suspense fallback={<Loading/>}> <LazyHome /> </React.Suspense>}/>
        <Route path="/learning" element={<React.Suspense fallback={<Loading />}> <LazyLearning /> </React.Suspense>}/> 
        <Route path="/about" element={<React.Suspense fallback={<Loading />}> <LazyAbout /> </React.Suspense>}/>
        <Route path="/services" element={<React.Suspense fallback={<Loading/>}> <LazyServices /> </React.Suspense>}/>
        <Route path="/contact" element={<React.Suspense fallback={<Loading />}> <LazyContact /> </React.Suspense>}/>
        <Route path="/projects" element={<React.Suspense fallback={<Loading />}> <LazyProjects /> </React.Suspense>}/>
        <Route path="/metin2" element={<React.Suspense fallback={<Loading/>}> <LazyMetin2 /> </React.Suspense>}/>
        <Route path="/lipsync" element={<React.Suspense fallback={<Loading />}> <LazyLipSync /> </React.Suspense>}/>
        <Route path="/principles" element={<React.Suspense fallback={<Loading/>}> <LazyPrinciples /> </React.Suspense>}/>
        <Route path="/rigging" element={<React.Suspense fallback={<Loading/>}> <LazyRigging /> </React.Suspense>}/>
        <Route path="/rangeofmovement" element={<React.Suspense fallback={<Loading/>}> <LazyRangeOfMovement /> </React.Suspense>}/>
        <Route path="/loading" element={<Loading />}/>
        
        {/* 2. Add the new /mindmap route here */}
        <Route path="/mindmap" element={<React.Suspense fallback={<Loading />}> <PrivateRoute component={LazyMindmap} /> </React.Suspense>}/>
          
      </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);